import { createSlice } from '@reduxjs/toolkit';

import { Sector } from '@/domain/impact/impact.entity';
import { createProjectFestival } from '@/domain/project-festival/actions/create-project-festival.action';
import { editProjectFestival } from '@/domain/project-festival/actions/edit-project-festival.action';
import { getProjectFestival } from '@/domain/project-festival/actions/get-project-festival.action';
import { getProjectsFestival } from '@/domain/project-festival/actions/get-projects-festival.action';
import { ProjectFestival } from '@/domain/project-festival/entities/project-festival.entity';

export type ProjectFestivalState = {
  items: ProjectFestival[];
  current: ProjectFestival | null;
  isFetchingProjects: boolean;
  isFetchingCurrentProject: boolean;
  isCreatingProject: boolean;
  isEditingProject: boolean;
  currentSector: Sector | null;
};

const initialState: ProjectFestivalState = {
  items: [],
  current: null,
  isFetchingProjects: false,
  isFetchingCurrentProject: false,
  isCreatingProject: false,
  isEditingProject: false,
  currentSector: null,
};

export const projectFestivalSlice = createSlice({
  name: 'projectFestival',
  initialState,
  reducers: {
    clearCurrent(state) {
      state.current = null;
    },
    setCurrentSector(state, action) {
      state.currentSector = action.payload;
    },
    setCalculateOptions(state, action) {
      if (!state.current) {
        return;
      }
      state.current.calculateOptions = action.payload;
    },
  },
  extraReducers(builder) {
    builder
      // getProjectsFestival
      .addCase(getProjectsFestival.pending, (state) => {
        state.isFetchingProjects = true;
      })
      .addCase(getProjectsFestival.fulfilled, (state, action) => {
        state.isFetchingProjects = false;
        state.items = action.payload;
      })
      .addCase(getProjectsFestival.rejected, (state) => {
        state.isFetchingProjects = false;
      })
      // getProjectFestival
      .addCase(getProjectFestival.pending, (state) => {
        state.isFetchingCurrentProject = true;
      })
      .addCase(getProjectFestival.fulfilled, (state, action) => {
        state.isFetchingCurrentProject = false;
        state.current = action.payload;
      })
      .addCase(getProjectFestival.rejected, (state) => {
        state.isFetchingCurrentProject = false;
      })
      // createProjectFestival
      .addCase(createProjectFestival.pending, (state) => {
        state.isCreatingProject = true;
      })
      .addCase(createProjectFestival.fulfilled, (state) => {
        state.isCreatingProject = false;
      })
      .addCase(createProjectFestival.rejected, (state) => {
        state.isCreatingProject = false;
      })
      // editProjectFestival
      .addCase(editProjectFestival.pending, (state) => {
        state.isEditingProject = true;
      })
      .addCase(editProjectFestival.fulfilled, (state) => {
        state.isEditingProject = false;
      })
      .addCase(editProjectFestival.rejected, (state) => {
        state.isEditingProject = false;
      });
  },
});
